import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import { fetchProfile } from '../services/fetchProfile'

export { useProfile, queryKey }

const queryKey = 'profile'

const useProfile = () => {
  const { hasPermissions } = useAuthenticatedUser()

  return useQuery({
    queryKey: [queryKey],
    queryFn: fetchProfile,
    enabled: hasPermissions,
  })
}
